// import articleList from 'page/article/list.vue'
// import detail from 'page/article/detail'
// import detail_pure from 'page/article/detail_pure'

console.log('detail_pure', detail_pure)
const articleList = () =>
  import(/* webpackChunkName: "info~articleList" */ 'page/article/list.vue')
const detail = () =>
  import(/* webpackChunkName: "info~detail" */ 'page/article/detail')
const detail_pure = () =>
  import(/* webpackChunkName: "info~detail_pure" */ 'page/article/detail_pure')
const articleIndex = () =>
  import(/* webpackChunkName: "info~articleIndex" */ 'page/article/index')
const articleDetail = () =>
  import(
    /* webpackChunkName: "info~articleDetail" */ 'page/article/articleDetail'
  )
let routes = [
  {
    path: '/info/tag',
    redirect: '/info',
    business: '文章'
  },
  {
    path: '/info',
    component: articleList,
    meta: {
      cache: 10 * 60 * 1000,
      business: '文章'
    }
  },
  {
    path: '/infopure/:articleId',
    component: detail_pure,
    meta: {
      cache: false
    }
  },

  // 文章列表-旧的路由格式
  {
    path: '/info/tag/:tag',
    component: articleList,
    meta: {
      cache: 10 * 60 * 1000,
      business: '文章'
    }
  },
  // 文章列表-新的路由格式。目的是和PC端的url格式保持一致，便于SEO。
  {
    path: '/info/tag_:tag',
    component: articleList,
    meta: {
      cache: 10 * 60 * 1000,
      business: '文章'
    }
  },

  {
    path: '/info/:articleId',
    component: detail,
    meta: {
      cache: 10 * 60 * 1000,
      business: '平台',
      pageName: '文章详情',
      category: '文章'
    }
  },

  {
    path: '/article/index',
    component: articleIndex,
    meta: {
      cache: 10 * 60 * 1000,
      business: '平台',
      pageName: '文章首页',
      category: '文章'
    }
  },

  {
    path: '/article/articleDetail',
    component: articleDetail,
    meta: {
      cache: 10 * 60 * 1000,
      business: '平台',
      pageName: '分类阅读',
      category: '文章'
    }
  }
]

export default routes
